// Group custom js files with ESbuild bundle feature

import "./functions.js";
import "./scroll-to.js";
import "./menu.js";
import "./password-validation.js";
import "./rating-stars.js";
import "./food-menu.js";
import "./my-tray.js";
import "./back-to-top.js";
import "./extra.js";
